import { FileCheck, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

interface Props {
  canCreate: boolean;
  onCreate: () => void;
}

// Right-pane idle state — shown when no row is selected and there's no
// in-memory draft. Thin wrapper over the shared EmptyState primitive.
export function SalesOrderDetailEmpty({ canCreate, onCreate }: Props) {
  return (
    <EmptyState
      icon={FileCheck}
      title="No sales order selected"
      description="Pick a sales order from the list, or start a new draft from a Firm Offer."
      action={
        canCreate ? (
          <Button onClick={onCreate}>
            <Plus className="mr-2 h-4 w-4" />
            New Sales Order
          </Button>
        ) : undefined
      }
    />
  );
}
